/**
 * Vuex getters for the "alerts" (notifications) module.
 *
 * Thin state accessors exposing the notification lists, counts, load state,
 * and error state as-is.
 */
export default {
    getAllNotifications: (state) => state.notifications,
    getUnreadNotificationsCount: (state) => state.unreadNotificationsCount, 
    getReadNotificationsCount: (state) => state.readNotificationsCount,
    getUnreadNotifications: (state) => state.unreadNotifications,
    getReadNotifications: (state) => state.readNotifications,
    getIsLoadedState: (state) => state.isLoaded,
    getNotificationsCount: (state) => state.count,
    getNotificationsError: (state) => state.notificationsError,
    getUnreadCountError: (state) => state.unreadCountError,
    // Loader getters are intentionally disabled while notifications refresh in the background.
    // getNotificationsLoading: (state) => state.notificationsLoading,
    // getUnreadCountLoading: (state) => state.unreadCountLoading,
  };
